module.exports = __webpack_public_path__ + "img/title-link.6f0c6faf.svg";